var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{domProps:{"textContent":_vm._s('Reminders')}}),_c('reminder-list-component',{attrs:{"viewModel":_vm.data}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }